module.exports = __webpack_public_path__ + "img/ic_phone_nor.cd2af6f0.svg";